import React from 'react'

const index = () => {
  return (
    <div>Salary</div>
  )
}

export default index